import {
  Flex,
  Box,
  Text,
  Stack,
  useDisclosure,
  useMediaQuery,
  SlideFade,
} from "@chakra-ui/react";
import Layout from "components/Layout";
import Link from "components/Link";
import Image from "components/Image";
import Button from "components/Button";
import HomeCard from "containers/HomeCard";
import HomeStepCard from "containers/HomeStepCard";
import heroImage from "../../public/home/hero.svg";
import speedImage from "../../public/home/speed.svg";
import speedSmallImage from "../../public/home/speed-small.png";
import expertsImage from "../../public/home/experts.svg";
import expertsSmallImage from "../../public/home/experts-small.png";
import partnershipImage from "../../public/home/partnership.svg";
import partnershipSmallImage from "../../public/home/partnership-small.png";
import logo101PayImage from "../../public/logo-101pay.png";
import bankApiImage from "../../public/home/image-bank-api.png";
import bankApiImageHover from "../../public/home/image-bank-api-hover.png";
import neoBankImage from "../../public/home/image-neobank-sdk.png";
import neoBankImageHover from "../../public/home/image-neobank-sdk-hover.png";
import preview101PayImage from "../../public/home/image-preview-101-pay.png";
import previewDigibankImage from "../../public/home/image-preview-digibank.png";
import bgBigCircleRight from "../../public/home/bg-circle-right.svg";
import bgBigCircleLeft from "../../public/home/bg-circle-left.svg";
import playCircleIcon from "../../public/home/icon-play-circle.svg";
import logoDigibankImage from "../../public/home/logo-digibank.png";
import Head from "next/head";
import { useRouter } from "next/router";
import FooterHalfCircle from "containers/FooterHalfCircle";
import ModalWatchVideo from "containers/ModalWatchVideo";
import { useState } from "react";

const dataBankingService = [
  {
    key: "bank-api",
    title: "Bank-API:\nOpen Banking as a Service",
    description:
      "For banks & fintechs wanting to launch Open Banking Solutions.",
    link: "https://www.youtube.com/embed/NCyFlX9AFuQ",
    image: bankApiImage,
    imageHover: bankApiImageHover,
  },
  {
    key: "neobank",
    title: "Neobank SDK:\nNeobank as a Service",
    description:
      "For bank & fintechs wishing to disrupt the market with innovative Digital / Embedded Finance Solutions.",
    link: "https://www.youtube.com/embed/OSerkQYuzjg",
    image: neoBankImage,
    imageHover: neoBankImageHover,
  },
];

const Index = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [urlVideo, setUrlVideo] = useState<string>("");
  const router = useRouter();
  const [isDesktop] = useMediaQuery("(min-width: 1024px)");
  const handleOpenWatchVideoModal = (url: string): void => {
    setUrlVideo(url);
    onOpen();
  };

  return (
    <Layout>
      <Head>
        <title>101Digital | Next Gen Banking - 101 Digital</title>
      </Head>
      <ModalWatchVideo isOpen={isOpen} onClose={onClose} src={urlVideo} />
      {/* HERO SECTION */}
      <Flex
        w="100%"
        align="center"
        flexDir={["column", null, null, null, null, "row"]}
        mt={["45px", null, null, null, null, "48px"]}
        mb={["61px", null, null, null, null, "172px"]}
        ml={[null, null, null, "auto", null, null, 0]}
        pl={[0, null, null, null, null, "16px", "12%", null, "16%", "20%"]}
      >
        <Flex
          flexDir="column"
          align={["center", null, null, null, null, "flex-start"]}
          maxW="603px"
        >
          <SlideFade
            in={true}
            offsetY="50px"
            transition={{ enter: { duration: 1 } }}
          >
            <Text
              as="h1"
              textStyle="h1"
              textAlign={["center", null, null, null, null, "left"]}
              mb={["13px", null, null, null, null, "15px"]}
              fontSize={["36px", null, null, null, null, "64px"]}
            >
              <Text>Digital Finance</Text>
              <Text color="secondary">Accelerated</Text>
            </Text>

            <Text
              textStyle="paragraphHighlighted"
              textAlign={["center", null, null, null, null, "left"]}
              px={["61px", null, null, null, null, 0]}
              mb={["16px", null, null, null, null, "32px"]}
              fontWeight="300"
            >
              We deliver world class digital platforms that enable your business
              growth and customer acquisition
            </Text>
            <Link
              href="/products"
              pos={["absolute", null, null, null, null, "static"]}
              top="16px"
              w="147.72px"
              color="#fff"
              bgColor="primary"
              borderRadius="md"
              textAlign="center"
              justifyContent="center"
              display={["none", null, null, null, null, "flex"]}
              style={{ textDecoration: "none" }}
              alignItems="center"
              left="16px"
              height={["40px", null, null, null, null, "54px"]}
              textStyle="buttonText"
            >
              Tell me more
            </Link>
          </SlideFade>
        </Flex>
        <Box maxW={[null, null, null, null, null, "1050px"]}>
          <SlideFade
            in={true}
            offsetY="50px"
            transition={{ enter: { duration: 1 } }}
          >
            <Image
              src={heroImage}
              alt="Reach customers globally in Transport, Leisure, Education, Entertainment, Employment, Family, and Health industries"
            />
          </SlideFade>
        </Box>
        <Link
          href="/products"
          w="291px"
          h="32px"
          mr="27px"
          mt="23px"
          mx="auto"
          color="#fff"
          bgColor="primary"
          borderRadius="md"
          textAlign="center"
          justifyContent="center"
          display={["flex", null, null, null, null, "none"]}
          style={{ textDecoration: "none" }}
          alignItems="center"
          textStyle="buttonText"
        >
          Tell me more
        </Link>
      </Flex>
      {/* 2ND SECTION */}
      <Text
        as="h2"
        textStyle="h2"
        mb={["20px", null, null, null, null, "27px"]}
        fontSize={["18px", null, null, null, null, "48px"]}
      >
        The 101 Digital Advantage
      </Text>
      <Text
        textStyle="paragraph"
        textAlign="center"
        px="66px"
        mb={["38px", null, null, null, null, "136.56px"]}
        fontSize={["14px", null, null, null, null, "21px"]}
        fontWeight="300"
      >
        Our ready made (as a Service) platform accelerates your product launch
      </Text>
      <Flex
        mb={["45px", null, null, null, null, "244px"]}
        maxW="1160px"
        w="100%"
        p={["16px"]}
        flexWrap={["wrap", null, null, null, null, "nowrap"]}
        justifyContent="space-between"
      >
        <HomeCard
          flex={["0 0 100%", null, null, null, null, "0 0 300px"]}
          maxW={["100%", null, null, null, null, "300px"]}
          mb={["40px", null, null, null, null, "0"]}
          display={["none", null, null, null, null, "flex"]}
          imageSrc={speedImage}
          imageAltText="Speed up product delivery"
          title={
            <>
              Accelerate your <br /> product launch
            </>
          }
          content="Use our proven platform and expertise to launch successful digital products."
        />
        <HomeCard
          flex={["0 0 100%", null, null, null, null, "0 0 300px"]}
          maxW={["100%", null, null, null, null, "300px"]}
          mb={["40px", null, null, null, null, "0"]}
          display={["flex", null, null, null, null, "none"]}
          imageSrc={speedSmallImage}
          imageAltText="Speed up product delivery"
          title={
            <>
              Accelerate your <br /> product launch
            </>
          }
          content="Use our proven platform and expertise to launch successful digital products."
        />
        <HomeCard
          flex={["0 0 100%", null, null, null, null, "0 0 300px"]}
          maxW={["100%", null, null, null, null, "300px"]}
          mb={["40px", null, null, null, null, "0"]}
          display={["none", null, null, null, null, "flex"]}
          imageSrc={expertsImage}
          imageAltText="Work with domain and technology experts"
          title={
            <>
              Engage with digital
              <br />
              platform experts
            </>
          }
          content="Collaborate with a team with a proven track record in delivering exceptional digital products."
          isReversed
        />
        <HomeCard
          flex={["0 0 100%", null, null, null, null, "0 0 300px"]}
          maxW={["100%", null, null, null, null, "300px"]}
          mb={["40px", null, null, null, null, "0"]}
          display={["flex", null, null, null, null, "none"]}
          imageSrc={expertsSmallImage}
          imageAltText="Work with domain and technology experts"
          title={
            <>
              Engage with digital
              <br />
              platform experts
            </>
          }
          content="Collaborate with a team with a proven track record in delivering exceptional digital products."
          isReversed
        />
        <HomeCard
          flex={["0 0 100%", null, null, null, null, "0 0 300px"]}
          maxW={["100%", null, null, null, null, "300px"]}
          mb={["40px", null, null, null, null, "0"]}
          display={["none", null, null, null, null, "flex"]}
          imageSrc={partnershipImage}
          imageAltText="Invest in a partnership"
          title={
            <>
              Invest in a
              <br />
              Partnership
            </>
          }
          content="Be empowered by a partnership that complements you every step of the way - from ideation to product launch."
        />
        <HomeCard
          flex={["0 0 100%", null, null, null, null, "0 0 300px"]}
          maxW={["100%", null, null, null, null, "300px"]}
          mb={["40px", null, null, null, null, "0"]}
          display={["flex", null, null, null, null, "none"]}
          imageSrc={partnershipSmallImage}
          imageAltText="Invest in a partnership"
          title="Invest in a Partnership"
          content="Be empowered by a partnership that complements you every step of the way - from ideation to product launch."
        />
      </Flex>
      {/* 3RD SECTION */}
      <Flex pos="relative" flexDir="column" alignItems="center" w="100%">
        <Box
          pos="absolute"
          width={["360px", "auto"]}
          right={["-60px", "0px"]}
          top="-169px"
          zIndex="-1"
        >
          <Image src={bgBigCircleRight} alt="101Pay" />
        </Box>

        <Text
          as="h2"
          textStyle="h2"
          mb={["20px", null, null, null, null, "39px"]}
          fontSize={["18px", null, null, null, null, "48px"]}
          textAlign={["center", null, null, "left"]}
        >
          Innovation Powered by Platform as a Service
        </Text>
        <Text
          textStyle="paragraph"
          textAlign="center"
          maxW={["300px", null, null, "1050px"]}
          mb={["38px", null, null, null, null, "55px"]}
          fontSize={["14px", null, null, null, null, "21px"]}
          fontWeight="300"
        >
          Accelerated product launch, reduced costs and risks, and a superior
          customer experience
        </Text>
        <Flex
          flexDir={["column", null, null, "row"]}
          justifyContent={["center", null, null, "space-between"]}
          alignItems={["center", null, null, "unset"]}
          w="100%"
          maxW="1182px"
          px="16px"
          mb={[null, null, null, "85px"]}
        >
          {dataBankingService.map((item, index) => (
            <Flex
              key={index}
              flex={["100%", null, null, null, null, "0 0 calc(50% - 15px)"]}
              flexDir={["column", null, null, null, null, "row"]}
            >
              <Box
                role="group"
                w="100%"
                maxW="560px"
                boxShadow={[
                  "null",
                  "null",
                  "null",
                  "0px 0px 12px rgba(0, 0, 0, 0.1)",
                ]}
                borderRadius="25px"
                p={["50px 30px", null, null, null, null, "70px 50px"]}
                mb={["0", null, null, null, null, "85px"]}
                bg={["transparent", null, null, null, null, "#fff"]}
                cursor="pointer"
                _hover={{
                  bg: "#2D4FA7",
                }}
                pointerEvents={["none", null, null, null, null, "auto"]}
                onClick={(e) =>
                  isDesktop
                    ? handleOpenWatchVideoModal(item.link)
                    : e.preventDefault()
                }
              >
                <Text
                  textStyle="h3"
                  fontSize={["16px", null, null, null, null, "36px"]}
                  textAlign={["center", null, null, null, null, "left"]}
                  fontWeight="700"
                  color="#102542"
                  m={["0 0 45px", null, null, null, null, "0 0 90px 10px"]}
                  maxW={["unset", null, null, null, null, "265px"]}
                  whiteSpace="pre-wrap"
                  _groupHover={{
                    color: "#fff",
                  }}
                >
                  {item.title}
                </Text>
                <Box
                  pos="relative"
                  maxW={[
                    item.key === "bank-api" ? "220px" : "280px",
                    null,
                    null,
                    "unset",
                  ]}
                  m={
                    item.key === "bank-api"
                      ? ["0 auto", null, null, "0"]
                      : ["0 auto", null, null, "-60px 0 -11px"]
                  }
                >
                  <Box
                    _groupHover={{
                      opacity: 0,
                    }}
                  >
                    <Image src={item.image} alt="" />
                  </Box>
                  <Box
                    pos="absolute"
                    top="0"
                    left="0"
                    w="100%"
                    h="100%"
                    pointerEvents="none"
                    opacity="0"
                    _groupHover={{
                      opacity: 1,
                    }}
                  >
                    <Image src={item.imageHover} alt="" />
                  </Box>
                </Box>

                <Text
                  textStyle="paragraph"
                  textAlign={["center", null, null, null, null, "left"]}
                  fontSize={["14px", null, null, null, null, "21px"]}
                  color="#777"
                  m={["40px auto 0", null, null, null, null, "50px 0 0px 10px"]}
                  maxW={["320px", null, null, null, null, "460px"]}
                  fontWeight="300"
                  lineHeight="1.3"
                  _groupHover={{
                    color: "#fff",
                  }}
                >
                  {item.description}
                </Text>
              </Box>
              <Flex
                display={["flex", null, null, null, null, "none"]}
                align="center"
                justify={["center", null, null, null, null, "left"]}
                mt={["80px"]}
                mb={["40px", null, null, , null, null, "unset"]}
                cursor="pointer"
                onClick={() => handleOpenWatchVideoModal(item.link)}
              >
                <Button
                  leftIcon={<Image width="20px" src={playCircleIcon} alt="" />}
                  colorScheme="teal"
                  variant="link"
                  color="primary"
                  fontWeight="700"
                  fontSize={["12px", null, null, null, null, "24px"]}
                >
                  Watch intro
                </Button>
              </Flex>
            </Flex>
          ))}
        </Flex>
      </Flex>

      {/* 4TH SECTION */}
      <Box
        pos="relative"
        w="100%"
        maxW="1200px"
        p={["80px 0", null, null, "140px 0 140px"]}
      >
        <Flex
          justify={["center", null, null, "space-between"]}
          flexDir={["column", null, null, "row"]}
        >
          <Box
            pos="absolute"
            width={["288px", "auto"]}
            left={["-135px", "-359px"]}
            top={["-350px", "-180px"]}
            zIndex="-1"
          >
            <Image src={bgBigCircleLeft} alt="101Pay" />
          </Box>
          <Flex flexDir="column" mb={["70px", null, null, "unset"]} px="16px">
            <Box
              maxW={["142px", null, null, "260px"]}
              mx="auto"
              mb={["20px", null, null, "80px"]}
            >
              <Image src={logo101PayImage} alt="101Pay" />
            </Box>
            <Box
              maxW={["200px", null, null, "unset"]}
              mx={["auto", null, null, "unset"]}
              order={[2, null, null, "unset"]}
              mt={["70px", null, null, "0"]}
            >
              <Image
                src={preview101PayImage}
                alt="101 Pay splash screen and dashboard"
              />
            </Box>
            <Text
              color="#777"
              fontSize={["14px", null, null, "21px"]}
              fontWeight="300"
              maxW={["280px", null, null, "425px"]}
              mt={["0", null, null, "50px"]}
              mx={["auto", null, null, "unset"]}
              textAlign={["center", null, null, "left"]}
              order={[1, null, null, "unset"]}
            >
              101 Pay is a feature-rich Super App for SMEs. With 101 Pay, SMEs
              can manage their Invoicing & Banking in one app. Banks & Fintechs
              can whitelabel 101 Pay.
            </Text>
          </Flex>
          <Box
            minheight="900px"
            background="rgba(0, 0, 0, 0.15)"
            width="1px"
            display={["none", null, null, "block"]}
          />

          <Flex flexDir="column" px="16px">
            <Box
              mx="auto"
              mt={["-22px"]}
              maxW={["250px", null, null, "470px"]}
              mb={["20px", null, null, "80px"]}
            >
              <Image src={logoDigibankImage} alt="DigiBank Logo" />
            </Box>
            <Box
              maxW={["330px", null, null, "unset"]}
              w={["100%", null, null, "unset"]}
              mx={["auto", null, null, "unset"]}
              order={[2, null, null, "unset"]}
              mt={["70px", null, null, "0"]}
            >
              <Image
                src={previewDigibankImage}
                alt="DigiBank Webapp on desktop and mobile"
              />
            </Box>
            <Text
              color="#777"
              fontSize={["14px", null, null, "21px"]}
              fontWeight="300"
              maxW={["280px", null, null, "425px"]}
              mt={["0", null, null, "90px"]}
              mx={["auto", null, null, "unset"]}
              textAlign={["center", null, null, "left"]}
              order={[1, null, null, "unset"]}
            >
              A modern digital banking platform for corporate and personal
              banking.
            </Text>
          </Flex>
        </Flex>

        <Flex justify="center" mt={["70px"]}>
          <Link
            href="/products"
            minW={["291px", null, null, null, null, "444px"]}
            color="primary"
            bgColor="white"
            borderWidth={"2px"}
            borderRadius="md"
            borderColor="#2d4fa7"
            textAlign="center"
            justifyContent="center"
            style={{ textDecoration: "none", borderColor: "#2d4fa7" }}
            alignItems="center"
            left="16px"
            display="flex"
            height={["40px", null, null, null, null, "54px"]}
            textStyle="buttonText"
          >
            Tell me more
          </Link>
        </Flex>
      </Box>

      {/* 5TH SECTION */}
      <Flex
        pos="relative"
        flexDir="column"
        alignItems="center"
        display={["flex", null, null, "none"]}
        w="100%"
        background="#fff"
        zIndex={2}
        pt={["0px", null, null, "112px"]}
      >
        <Box
          pos="absolute"
          display={["block", "none"]}
          width={["360px", "auto"]}
          right={["-60px", "-276px"]}
          top="-50px"
          zIndex="-1"
        >
          <Image src={bgBigCircleRight} alt="101Pay" />
        </Box>

        <Text
          as="h2"
          textStyle="h2"
          mb={["20px", null, null, null, null, "39px"]}
          fontSize={["18px", null, null, null, null, "38px"]}
        >
          Our Collaborative Approach
        </Text>
        <Text
          textStyle="paragraph"
          textAlign="center"
          px="59px"
          mb={["34.66px", null, null, null, null, "79px"]}
          fontSize={["0.875rem", null, null, null, null, "24px"]}
        >
          We follow a simple three step process to turn your idea into a great
          product.
        </Text>
        <Stack
          direction={["column", null, null, null, null, "row"]}
          spacing={["59.59px", null, null, null, null, "17px"]}
          mb={["56.25px", null, null, null, null, "73px"]}
        >
          <HomeStepCard
            step={1}
            title="Discover"
            description="Understand your vision for your business and products"
          />
          <HomeStepCard
            step={2}
            title="Partner and Co-Create"
            description="Leverage our platform to rapidly evolve the products"
          />
          <HomeStepCard
            step={3}
            title="Launch"
            description="Launch the product to market quickly and continue to refine"
          />
        </Stack>
        <Button
          href="#"
          minW={["291px", null, null, null, null, "444px"]}
          mb={["55px", null, null, null, null, "99px"]}
          onClick={() => router.push("/approach")}
        >
          Understand our approach
        </Button>
      </Flex>

      {/* 6TH SECTION */}
      <FooterHalfCircle
        title="Trusted by global organisations"
        description="Customers choose 101 Digital for our proven experience and accelerated time to market."
        buttonTitle="See customer results"
        buttonLink="/success-stories"
      />
    </Layout>
  );
};

export default Index;
